import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { getCompany } from "@/publicjs/company";
import { idLocalStore } from "@/publicjs/localStorage";
import { imageInBase64 } from "@/publicjs/logoCompany";
import { getCurrentDate } from "@/publicjs/currentDate";
import { closeAlert, errorActions, uploadData } from "@/alerts";
import styles from "@/publicjs/styles";
import { money, format } from "@/publicjs/money";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export const exportToPDF = async (registers, dateStart, dateEnd, summary) => {
  await uploadData(
    "Generando reporte",
    "Espera un momento mientras preparamos el PDF de caja chica...",
  );

  const company = await getCompany(await idLocalStore());
  const base64Image = await imageInBase64(company.companyLogo);

  try {
    const docDefinition = {
      pageSize: "A4",
      pageOrientation: "landscape",
      pageMargins: [24, 140, 24, 24],
      header(currentPage, pageCount, pageSize) {
        return [
          {
            columns: [
              {
                width: 100,
                stack: [{ image: base64Image, fit: [80, 80] }],
                alignment: "left",
                margin: [0, 10, 0, 0],
              },
              {
                width: 240,
                stack: [
                  {
                    text: company.companyName,
                    fontSize: styles.fontSize.pdf.xl,
                    alignment: "left",
                    bold: true,
                    color: styles.colors.colorTitle,
                  },
                  {
                    text: "Dirección: " + company.companyAddress,
                    fontSize: styles.fontSize.pdf.sm,
                    alignment: "left",
                    color: styles.colors.colorDescription,
                  },
                  {
                    text: "Tel: " + company.companycellphone,
                    fontSize: styles.fontSize.pdf.sm,
                    alignment: "left",
                    color: styles.colors.colorDescription,
                  },
                ],
                margin: [12, 10, 24, 0],
              },
              {
                width: "*",
                stack: [
                  {
                    text: company.storeName,
                    fontSize: styles.fontSize.pdf.lg,
                    alignment: "right",
                    color: styles.colors.colorTitle,
                    bold: true,
                  },
                  {
                    text: "Reporte de caja chica",
                    fontSize: styles.fontSize.pdf.sm,
                    alignment: "right",
                    color: styles.colors.colorBlue,
                    bold: true,
                  },
                  {
                    text: `Desde ${dateStart} hasta ${dateEnd}`,
                    fontSize: styles.fontSize.pdf.sm,
                    alignment: "right",
                    color: styles.colors.colorDescription,
                  },
                  {
                    text: getCurrentDate(),
                    fontSize: styles.fontSize.pdf.sm,
                    alignment: "right",
                    color: styles.colors.colorDescription,
                    bold: true,
                  },
                ],
                margin: [0, 10, 24, 0],
              },
            ],
            margin: [24, 12, 0, 0],
          },
          {
            canvas: [
              { type: "rect", x: 24, y: 90, w: pageSize.width - 48, h: 2 },
            ],
            margin: [0, 10],
          },
        ];
      },
      footer(currentPage, pageCount) {
        return {
          text: `Página ${currentPage} de ${pageCount}`,
          alignment: "right",
          fontSize: styles.fontSize.pdf.sm,
          color: styles.colors.colorDescription,
          margin: [0, 0, 24, 0],
        };
      },
      content: [
        {
          text: `Total desembolsado: ${money()} ${format(
            summary.total_desembolsado || 0,
          )} | Movimientos: ${summary.total_movimientos || 0} | Cajas: ${
            summary.total_cajas || 0
          }`,
          margin: [0, 0, 0, 16],
          color: styles.colors.colorTitle,
          bold: true,
        },
        {
          table: {
            headerRows: 1,
            widths: [50, 90, 80, 90, 90, "*", 80, 100],
            body: [
              [
                {
                  text: "Caja",
                  bold: true,
                  border: [false, false, false, true],
                },
                {
                  text: "Responsable",
                  bold: true,
                  border: [false, false, false, true],
                },
                {
                  text: "Referencia",
                  bold: true,
                  border: [false, false, false, true],
                },
                {
                  text: "Beneficiario",
                  bold: true,
                  border: [false, false, false, true],
                },
                {
                  text: "Departamento",
                  bold: true,
                  border: [false, false, false, true],
                },
                {
                  text: "Concepto",
                  bold: true,
                  border: [false, false, false, true],
                },
                {
                  text: "Monto",
                  bold: true,
                  border: [false, false, false, true],
                  alignment: "right",
                },
                {
                  text: "Fecha",
                  bold: true,
                  border: [false, false, false, true],
                },
              ],
              ...registers.map((register) => [
                {
                  text: String(register.idcaja_chica),
                  border: [false, false, false, false],
                },
                {
                  text: register.nombres,
                  border: [false, false, false, false],
                },
                {
                  text: register.numero_referencia || "---",
                  border: [false, false, false, false],
                },
                {
                  text: register.beneficiario || "---",
                  border: [false, false, false, false],
                },
                {
                  text: register.departamento || "---",
                  border: [false, false, false, false],
                },
                {
                  text: register.concepto,
                  border: [false, false, false, false],
                },
                {
                  text: `${money()} ${format(register.monto)}`,
                  border: [false, false, false, false],
                  alignment: "right",
                },
                {
                  text: register.fecha_de_desembolso,
                  border: [false, false, false, false],
                },
              ]),
            ],
          },
        },
      ],
    };

    pdfMake.createPdf(docDefinition).open();
    await closeAlert();
  } catch (error) {
    errorActions("No pudimos generar el PDF del reporte de caja chica");
  }
};
